import UserData from "../../../components/profile/UserData";
import { useContext, useEffect } from "react";
import UserContext from "../../../context/UserContext";
import { useNavigate } from "react-router-dom";
function Profile(props) {
  const navigate = useNavigate();
  const { userData, isLogged } = useContext(UserContext);
  const { userInfo } = userData;
  useEffect(() => {
    if (!isLogged) {
      navigate("/join/signin");
    }
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="page flex flex-col items-center justify-center h-auto py-32 gap-5">
      {isLogged && <UserData userInfo={userInfo} />}
    </div>
  );
}
export default Profile;
